import React, { useEffect, useLayoutEffect, useState, useRef } from "react";
import { getProduct } from "../scripts/productdata";
import { fonts, fontColors } from "../scripts/fonts";
import { useSearchParams } from "react-router-dom";
import { fontSize, renderUrl } from "../scripts/helpers";
import Switch from "react-switch";

const Generator = ({ price, id, name, type, description }) => {
  const [tabOption, setTabOption] = useState(
    type === "small" ? "backgrounds" : "illustrations"
  );
  const [data, setData] = useState({});
  const [optionList, setOptionList] = useState([]);
  const [product, setProduct] = useState({});
  const [categoryIndex, setCategoryIndex] = useState(0);
  const [activeImage, setActiveImage] = useState();
  const [chosenImage, setChosenImage] = useState();
  const [activeBackground, setActiveBackground] = useState();
  const [chosenBackground, setChosenBackground] = useState("");
  const [activeFont, setActiveFont] = useState(0);
  const [chosenFont, setChosenFont] = useState("Quicksand");
  const [firstText, setFirstText] = useState("");
  const [secondText, setSecondText] = useState("");
  const [thirdText, setThirdText] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [activeFontColor, setActiveFontColor] = useState(0);
  const [chosenFontColor, setChosenFontColor] = useState("000000");
  const [searchParams, setSearchParams] = useSearchParams();
  const [renderedUrl, setRenderedUrl] = useState("");
  const [showSvg, setShowSvg] = useState(type === "small" ? false : true);
  const [percentageWidth, setPercentageWidth] = useState("60%");
	const [showIllustration, setShowIllustration] = useState('');
  const innerNote = useRef();
  const hideSvgForSmall = useRef(false);

  useLayoutEffect(() => {
    const fetchProduct = async () => {
      const result = await getProduct(id, type);
      const defaultBackground = result.backgrounds[0].items[0];
      const defaultIllustration = result.illustrations
        ? result.illustrations[0].items[0]
        : null;
      const oldSettings = localStorage.getItem("savedSettings")
        ? JSON.parse(localStorage.getItem("savedSettings"))
        : {};
      let texts = [oldSettings.text1, oldSettings.text2, oldSettings.text3];
      setData(result);
      setProduct(result.product);
      setOptionList(result[tabOption][categoryIndex].items);
      setPageCount(result[tabOption][categoryIndex].items.length / 12);

      const initialChosenBackground =
        searchParams.get("background") ||
          oldSettings.background ||
          defaultBackground.color;
      setChosenBackground(initialChosenBackground);

      const initialActiveBackground =
        searchParams.get("activeBackground") ||
          oldSettings.activeBackground ||
          defaultBackground.id;
      setActiveBackground(initialActiveBackground);

      let font =
        searchParams.get("fontfamily")?.replace(/[+]/g, " ") ||
        oldSettings.fontfamily ||
        "Quicksand";
      setChosenFont(font);

      const initialFirstText =
        searchParams.get("text1")?.replace(/[“”'"]/g, "") ||
          oldSettings.text1 ||
          "";
      setFirstText(initialFirstText);
      texts[0] = initialFirstText;

      const initialFontColor =
        searchParams.get("fontColor") || oldSettings.fontColor || "000000";
      setChosenFontColor(initialFontColor);

      let initialChosenImage = null;
      let initialActiveImage = null;
      let initialSecondText = "";
      let initialThirdText = "";
      let initialShowSvg = type === "small" ? false : true;
      let initialShowIllustration = '';
      if (type !== "small") {
        initialChosenImage =
          searchParams.get("illustration") ||
            oldSettings.illustration ||
            (defaultIllustration && defaultIllustration.image && defaultIllustration.image.url);
        setChosenImage(initialChosenImage);

        initialShowIllustration =
          oldSettings.showSvg !== undefined
            ? (oldSettings.showSvg ? 'ja' : 'nej')
            : 'ja';
        setShowIllustration(initialShowIllustration);

        setTimeout(() => {
          setShowSvg(
            oldSettings.showSvg !== undefined ? oldSettings.showSvg : true
          );
        }, 300);

        initialActiveImage =
          searchParams.get("activeImage") ||
            oldSettings.activeImage ||
            (defaultIllustration && defaultIllustration.id);
        setActiveImage(initialActiveImage);

        initialSecondText =
          searchParams.get("text2")?.replace(/[“”'"]/g, "") ||
            oldSettings.text2 ||
            "";
        setSecondText(initialSecondText);
        texts[1] = initialSecondText;

        initialThirdText =
          searchParams.get("text3")?.replace(/[“”'"]/g, "") ||
            oldSettings.text3 ||
            "";
        setThirdText(initialThirdText);
        texts[2] = initialThirdText;
      }

      setPercentageWidth(
        oldSettings.showSvg !== undefined
          ? oldSettings.showSvg
            ? (Math.round(result.product.contentPercentage) / 100) *
              (500 - result.product.padding.x * 2)
            : "100%"
          : "60%"
      );

      let textWidth =
        oldSettings.showSvg !== undefined
          ? oldSettings.showSvg
            ? (Math.round(result.product.contentPercentage) / 100) *
              (500 - result.product.padding.x * 2)
            : 100 * (500 - result.product.padding.x * 2)
          : (Math.round(result.product.contentPercentage) / 100) *
            (500 - result.product.padding.x * 2);

      setTimeout(() => {
        checkFontSize(
          font,
          ["firstText", "secondText", "thirdText"],
          texts,
          textWidth
        );
      }, 300);

      renderUrl(
        texts[0] || "",
        texts[1] || "",
        texts[2] || "",
        initialChosenImage,
        initialChosenBackground,
        font,
        initialFontColor,
        initialShowSvg,
        initialShowIllustration,
        type,
        setRenderedUrl
      );
    };

    fetchProduct(); 
  }, []);

  // run hideSvg for small type after product loads and DOM is ready
  useEffect(() => {
    if (type === "small" && product && product.contentPercentage && !hideSvgForSmall.current) {
      hideSvgForSmall.current = true;
      // ensure DOM element exists before running hideSvg
      setTimeout(() => {
        if (document.getElementById("textBox")) {
          hideSvg();
        }
      }, 400);
    } 
  }, [product]);

  useLayoutEffect(() => {
    if (data[tabOption]) {
      setOptionList(data[tabOption][categoryIndex].items);
      setPageCount(data[tabOption][categoryIndex].items.length / 12);
    }
  }, [categoryIndex, tabOption]);

  useEffect(() => {
    setSearchParams({
      illustration: chosenImage,
      activeImage: activeImage,
      background: chosenBackground,
      activeBackground: activeBackground,
      fontfamily: chosenFont,
      fontColor: chosenFontColor || "000000",
      text1: firstText,
      text2: secondText,
      text3: thirdText,
      showIllustration: showIllustration,
    });
    renderUrl(
      firstText,
      secondText,
      thirdText,
      activeImage,
      activeBackground,
      chosenFont,
      chosenFontColor,
      showSvg,
			showIllustration,
      type,
      setRenderedUrl
    );
  }, [
    chosenImage,
    chosenBackground,
    chosenFont,
    chosenFontColor,
    firstText,
    secondText,
    thirdText,
    showSvg,
  ]);

  const checkFontSize = (font, idList, textList, clientWidth) => {
    let maxTextSize = type === "small" ? 150 : 100;
    let textContainer = document.getElementById("textBox");
    if (!textContainer) return;

    let optimalSizes = [];

    idList.forEach((id, index) => {
      let inputRow = document.getElementById(id);
      if (!inputRow) {
        optimalSizes.push(8);
        return;
      }
      
      inputRow.innerText = textList[index] || "";
      inputRow.style.fontFamily = font;

      // Check if this specific text contains descender letters
      let hasDescenders = textList[index] && textList[index].match(/[gjpqyJGPQY]/);

      let bestSize = 8;
      
      for (let i = maxTextSize; i >= 8; i--) {
        inputRow.style.fontSize = `${i}px`;
        // Dynamic line-height: 1.3x if descenders present in this text, 1.0x if not
        inputRow.style.lineHeight = hasDescenders ? `${Math.ceil(i * 1.3)}px` : `${i}px`;

        // Force a reflow to ensure accurate measurements
        inputRow.offsetHeight; 
        
        // Use the passed clientWidth if available, otherwise fall back to container width
        let availableWidth = clientWidth || textContainer.clientWidth;
        
        // Ensure we don't use a width larger than what was actually set
        if (clientWidth && textContainer.style.width) {
          let setWidth = parseInt(textContainer.style.width);
          if (!isNaN(setWidth)) {
            availableWidth = Math.min(availableWidth, setWidth);
          }
        }

        if (inputRow.scrollWidth <= availableWidth) {
          bestSize = i;
          break;
        }
      }
      
      optimalSizes.push(bestSize);
    });

    // Step 2: Apply optimal sizes and check total height with dynamic line-height
    let totalHeight = 0;
    idList.forEach((id, index) => {
      let inputRow = document.getElementById(id);
      if (inputRow) {
        // Check if this specific text contains descender letters
        let hasDescenders = textList[index] && textList[index].match(/[gjpqyJGPQY]/);
        inputRow.style.fontSize = `${optimalSizes[index]}px`;
        inputRow.style.lineHeight = hasDescenders ? `${Math.ceil(optimalSizes[index] * 1.3)}px` : `${optimalSizes[index]}px`;
        
        inputRow.offsetHeight; // Force reflow
        totalHeight += inputRow.offsetHeight;
      }
    });

    // Step 3: If total height exceeds container, scale down proportionally
    let availableHeight = textContainer.offsetHeight;
    if (totalHeight > availableHeight) {
      let scaleFactor = Math.max(0.3, availableHeight / totalHeight); 
      
      idList.forEach((id, index) => {
        let inputRow = document.getElementById(id);
        if (inputRow) {
          // Check if this specific text contains descender letters
          let hasDescenders = textList[index] && textList[index].match(/[gjpqyJGPQY]/);
          let newSize = Math.max(8, Math.floor(optimalSizes[index] * scaleFactor));
          inputRow.style.fontSize = `${newSize}px`;
          inputRow.style.lineHeight = hasDescenders ? `${Math.ceil(newSize * 1.3)}px` : `${newSize}px`;
        }
      });
    }

    return Math.max(...optimalSizes);
  };

  const saveInLocalStorage = (newSetting) => {
    let savedSettings = JSON.parse(localStorage.getItem("savedSettings"));
    localStorage.setItem(
      "savedSettings",
      JSON.stringify({ ...savedSettings, ...newSetting })
    );
  };

  const changeTab = (type) => {
    setTabOption(type);
    setCategoryIndex(0);
    setCurrentPage(0);
  };

  const changeCategory = (index) => {
    setCategoryIndex(index);
    setCurrentPage(0);
  };

  const chooseImage = (url, index) => {
    setChosenImage(url);
    setActiveImage(index);
    saveInLocalStorage({ illustration: url, activeImage: index });
  };

  const chooseBackground = (background, index) => {
    setChosenBackground(background);
    setActiveBackground(index);
    saveInLocalStorage({ background: background, activeBackground: index });
  };

  const chooseFont = (font, index) => {
    setChosenFont(font);
    setActiveFont(index);
    checkFontSize(
      font,
      ["firstText", "secondText", "thirdText"],
      [firstText, secondText, thirdText],
      0
    );
    saveInLocalStorage({ fontfamily: font });
  };

  const chooseFontColor = (color, index) => {
    setChosenFontColor(color);
    setActiveFontColor(index);
    saveInLocalStorage({ fontColor: color });
  };

  const hideSvg = () => {
    const newShowSvg = !showSvg;
    setShowSvg(newShowSvg);
		setShowIllustration(newShowSvg ? 'ja' : 'nej');
    setPercentageWidth(
      newShowSvg
        ? (Math.round(product.contentPercentage) / 100) *
            (500 - product.padding.x * 2)
        : "100%"
    );
    saveInLocalStorage({ showSvg: newShowSvg });
    document.getElementById("textBox").style.opacity = 0;
   document.getElementById("textBox").style.paddingRight = "0px";
    setTimeout(() => {
      let innerContainer = document.querySelector('.inner');
      let textBox = document.getElementById("textBox");
      let actualWidth;
      
      if (newShowSvg) {
        actualWidth = (Math.round(product.contentPercentage) / 100) * (500 - (product.padding?.x * 2 || 0));
        textBox.style.width = `${actualWidth}px`;
        
        // Add small delay to ensure DOM has updated  
        setTimeout(() => {
          checkFontSize(
            chosenFont,
            ["firstText", "secondText", "thirdText"],
            [firstText, secondText, thirdText],
            actualWidth
          );
        }, 50);
      } else {
        let computedStyle = window.getComputedStyle(textBox);
        let boxWidth = textBox.offsetWidth;
        let paddingLeft = parseFloat(computedStyle.paddingLeft) || 0;
        let paddingRight = parseFloat(computedStyle.paddingRight) || 0;
        
        actualWidth = Math.max(200, boxWidth - paddingLeft - paddingRight);
        textBox.style.width = `${actualWidth}px`;
        
        let maxTextSize = type === "small" ? 150 : 100;
        let maxWorkingSize = 8;
        
        for (let size = maxTextSize; size >= 8; size--) {
          let allFit = true;
          let totalHeight = 0;
          
          ["firstText", "secondText", "thirdText"].forEach((id, index) => {
            let inputRow = document.getElementById(id);
            if (!inputRow) return;
            
            let text = [firstText, secondText, thirdText][index];
            // Check if this specific text contains descenders
            let hasDescenders = text && text.match(/[gjpqyJGPQY]/);
            inputRow.innerText = text || "";
            inputRow.style.fontFamily = chosenFont;
            inputRow.style.fontSize = `${size}px`;
            // Dynamic line-height based on descenders in this specific text
            inputRow.style.lineHeight = hasDescenders ? `${Math.ceil(size * 1.3)}px` : `${size}px`;
            
            if (inputRow.scrollWidth > actualWidth) {
              allFit = false;
            }
            
            totalHeight += inputRow.offsetHeight;
          });
          
          if (totalHeight > textBox.offsetHeight) {
            allFit = false;
          }
          
          if (allFit) {
            maxWorkingSize = size;
            break;
          }
        }
        
        let finalSize = Math.max(8, maxWorkingSize - 2);
        ["firstText", "secondText", "thirdText"].forEach((id, index) => {
          let inputRow = document.getElementById(id);
          if (inputRow) {
            let text = [firstText, secondText, thirdText][index];
            // Check if this specific text contains descenders
            let hasDescenders = text && text.match(/[gjpqyJGPQY]/);
            inputRow.style.fontSize = `${finalSize}px`;
            // Apply dynamic line-height to final size based on this text's descenders
            inputRow.style.lineHeight = hasDescenders ? `${Math.ceil(finalSize * 1.3)}px` : `${finalSize}px`;
          }
        });
        
        console.log('Hidden SVG - Max size found:', maxWorkingSize, 'Applied size:', finalSize);
      }
      
      textBox.style.opacity = 1;
    }, 400);
  };

  const mmToPx = (size) => {
    return (500 * size) / productWidthInmm;
  };

  let productHeightInmm = product && product.height;
  let productWidthInmm = product && product.width;
  let contentPercentage = product && product.contentPrcentage;
  let imagePercentage = product && product.imagePercentage;
  let maxContentHeight = product && product.maxTextHeight;
  let productHeightInpx = (500 * productHeightInmm) / productWidthInmm;
  let paddingX = product && mmToPx(product.padding?.x || 1);
  let paddingY = product && mmToPx(product.padding?.y || 1);

  const fontSize = (font, id, text, clientWidth) => {
    if (type === "small") {
      return checkFontSize(font, [id], [text], clientWidth);
    } else {
      return checkFontSize(
        font,
        ["firstText", "secondText", "thirdText"],
        [firstText, secondText, thirdText],
        clientWidth
      );
    }
  };

  const containerWidth = document.querySelector(".note-container__note")
    ? document.querySelector(".note-container__note").clientWidth
    : "500px";
  const backgroundStyle = {
    background: chosenBackground.includes("http")
      ? `url(${chosenBackground})`
      : chosenBackground,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height:
      containerWidth < 500
        ? `${0.46666599999999997 * containerWidth}px`
        : `${productHeightInpx}px`,
    width: containerWidth < 500 ? "100%" : "500px",
    paddingRight:
      containerWidth < 500
        ? `${0.041666600000000005 * containerWidth}px`
        : `${paddingX}px`,
    paddingLeft:
      containerWidth < 500
        ? `${0.041666600000000005 * containerWidth}px`
        : `${paddingX}px`,
    paddingTop:
      containerWidth < 500
        ? `${0.0333334 * containerWidth}px`
        : `${paddingY}px`,
    paddingBottom:
      containerWidth < 500
        ? `${0.0333334 * containerWidth}px`
        : `${paddingY}px`,
    gap: 100 - contentPercentage - imagePercentage + "%",
  };

  const illustrationStyle = {
    width: `calc(${imagePercentage}%)`,
    height: "auto",
  };

  const textStyle = {
    width: percentageWidth,
    fontFamily: chosenFont,
    color: chosenFontColor,
    height: showSvg ? "auto" : `${productHeightInpx - (paddingY * 1)}px`,
    maxHeight: `${productHeightInpx}px`,
    maxWidth: showSvg ? `${contentPercentage}%` : "100%",
  };

  let categoryOptions;
  let choiceOptions;

  if (data[tabOption]) {
    categoryOptions = data[tabOption].map((option, index) => {
      return (
        <div
          className={
            categoryIndex == index ? "menu-option active" : "menu-option"
          }
          key={index}
          onClick={() => changeCategory(index)}
        >
          {option.term.name}
        </div>
      );
    });

    choiceOptions = optionList
      .filter(
        (option, index) =>
          index >= currentPage * 12 && index < (currentPage + 1) * 12
      )
      .map((option, index) => {
        if (tabOption == "illustrations") {
          return (
            <div
              className={activeImage == option.id ? "choice active" : "choice"}
              key={index}
              onClick={() => chooseImage(option.image.url, option.id)}
            >
              <img src={option.image.url} alt="" />
            </div>
          );
        } else if (tabOption == "backgrounds") {
          return (
            <div
              id={option.id}
              className={
                activeBackground == option.id
                  ? "choice color active"
                  : "choice color"
              }
              key={index}
            >
              <div
                className="background"
                style={
                  option.image.length == 0
                    ? { background: `${option.color}` }
                    : { background: `url(${option.image.url})` }
                }
                onClick={() =>
                  chooseBackground(
                    option.color ? option.color : option.image.url,
                    option.id
                  )
                }
              ></div>
            </div>
          );
        }
      });
  }

  let fontOptions = fonts.map((font, index) => {
    return (
      <div
        className={activeFont == index ? "choice font active" : "choice font"}
        key={index}
        style={{ fontFamily: font }}
        onClick={() => {
          chooseFont(font, index);
        }}
      >
        {font}
      </div>
    );
  });

  let fontColorOptions = fontColors.map((color, index) => {
    return (
      <div
        key={index}
        className={
          activeFontColor == index ? "choice color active" : "choice color"
        }
      >
        <div
          className="background"
          key={index}
          style={{ background: `${color}` }}
          onClick={() => chooseFontColor(color, index)}
        ></div>
      </div>
    );
  });

  return (
    <div className="note-configurator">
      <div className="option-container">
        <div className="option-container__tabs">
          {type !== "small" && (
            <div
              className={tabOption == "illustrations" ? "tab active" : "tab"}
              onClick={() => changeTab("illustrations")}
            >
              Illustration
            </div>
          )}
          <div
            className={tabOption == "backgrounds" ? "tab active" : "tab"}
            onClick={() => changeTab("backgrounds")}
          >
            Bakgrund
          </div>
          <div
            className={tabOption == "fonts" ? "tab active" : "tab"}
            onClick={() => changeTab("fonts")}
          >
            Typsnitt
          </div>
        </div>
        <div className="option-container__content">
          <div className="option-container__menu">
            {type !== "small" && (
              <>
                <div className="svg-toggle">
                  <Switch
                    onChange={() => hideSvg()}
                    checked={showSvg}
                    onColor="#8066FF"
                    offColor="#EFF0F1"
                    offHandleColor="#8066FF"
                  />
                  <div className="text">Visa motiv</div>
                </div>
              </>
            )}
            {tabOption != "fonts" ? (
              <>{categoryOptions}</>
            ) : (
              <>
                <div
                  className={
                    categoryIndex == 0 ? "menu-option active" : "menu-option"
                  }
                  onClick={() => changeCategory("Font", 0)}
                >
                  Font
                </div>
                <div
                  className={
                    categoryIndex == 1 ? "menu-option active" : "menu-option"
                  }
                  onClick={() => changeCategory("Färg", 1)}
                >
                  Färg
                </div>
              </>
            )}
          </div>
          <div className="option-container__choices">
            <div className="choices-container">
              {tabOption != "fonts" ? (
                <>
                  {choiceOptions}
                  <div className="choices-pagination">
                    <i
                      className={
                        currentPage === 0
                          ? "fas fa-chevron-left inactive"
                          : "fas fa-chevron-left"
                      }
                      onClick={() =>
                        currentPage !== 0 && setCurrentPage(currentPage - 1)
                      }
                    ></i>
                    <div className="pages">
                      Sida {currentPage + 1} av {Math.ceil(pageCount)}
                    </div>
                    <i
                      className={
                        currentPage === pageCount - 1
                          ? "fas fa-chevron-right inactive"
                          : "fas fa-chevron-right"
                      }
                      onClick={() =>
                        currentPage !== pageCount - 1 &&
                        setCurrentPage(currentPage + 1)
                      }
                    ></i>
                  </div>
                </>
              ) : (
                <>
                  {categoryIndex == 0 ? (
                    <>{fontOptions}</>
                  ) : (
                    <>{fontColorOptions}</>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="note-container">
        <div className="note-container__text">
          <div className="input-container">
            <input
              type="text"
              value={firstText}
              placeholder="Textrad #1"
              maxLength={17}
              onChange={(event) => {
                setFirstText(event.target.value);
                setTimeout(() => {
                  checkFontSize(
                    chosenFont,
                    ["firstText", "secondText", "thirdText"],
                    [event.target.value, secondText, thirdText],
                    document.getElementById("textBox")?.clientWidth || 0
                  );
                }, 10);
                saveInLocalStorage({ text1: event.target.value });
              }}
            />
            <span className="text-length">{firstText.length} / 17</span>
          </div>
          {type !== "small" && (
            <>
              <div className="input-container">
                <input
                  type="text"
                  value={secondText}
                  placeholder="Textrad #2"
                  maxLength={17}
                  onChange={(event) => {
                    setSecondText(event.target.value);
                    setTimeout(() => {
                      checkFontSize(
                        chosenFont,
                        ["firstText", "secondText", "thirdText"],
                        [firstText, event.target.value, thirdText],
                        document.getElementById("textBox")?.clientWidth || 0
                      );
                    }, 10);
                    saveInLocalStorage({ text2: event.target.value });
                  }}
                />
                <span className="text-length">{secondText.length} / 17</span>
              </div>
              <div className="input-container">
                <input
                  type="text"
                  value={thirdText}
                  placeholder="Textrad #3"
                  maxLength={17}
                  onChange={(event) => {
                    setThirdText(event.target.value);
                    setTimeout(() => {
                      checkFontSize(
                        chosenFont,
                        ["firstText", "secondText", "thirdText"],
                        [firstText, secondText, event.target.value],
                        document.getElementById("textBox")?.clientWidth || 0
                      );
                    }, 10);
                    saveInLocalStorage({ text3: event.target.value });
                  }}
                />
                <span className="text-length">{thirdText.length} / 17</span>
              </div>
            </>
          )}
        </div>
        <div className="note-container__note">
          <div className="inner" ref={innerNote} style={backgroundStyle}>
            {showSvg && (
              <img src={chosenImage} alt="" style={illustrationStyle} />
            )}
            <div className="text-box" style={textStyle} id="textBox">
              <p className="text-row" id="firstText">
                {firstText}
              </p>
              {type !== "small" && (
                <>
                  <p className="text-row" id="secondText">
                    {secondText}
                  </p>
                  <p className="text-row" id="thirdText">
                    {thirdText}
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="note-container__price desktop">
          <p>{description}</p>
          <div className="price">
            {price}kr <span className="extra-info">per set</span>
          </div>
          {chosenBackground && (
            <a
              rel="nofollow"
              className="add_to_cart_button button"
              href={`/?add-to-cart=${id}&note_url=${renderedUrl}`}
            >
              Lägg i varukorg
            </a>
          )}
        </div>
      </div>
      <div className="note-container__price mobile">
        <p>{description}</p>
        <div className="price">
          {price}kr <span className="extra-info">per set</span>
        </div>
        {chosenBackground && (
          <a
            rel="nofollow"
            className="add_to_cart_button button"
            href={`/?add-to-cart=${id}&note_url=${renderedUrl}`}
          >
            Lägg i varukorg
          </a>
        )}
      </div>
    </div>
  );
};

export default Generator;
